import React from "react"
import { Flex, Box, Heading } from "rebass"
import { motion } from "framer-motion"

import Cloud from "./cloud"

const BlueCloud = () => (
  <Box css={{ position: "absolute" }} sx={{ top: [-60, 100] }}>
    <motion.div
      animate={{ x: "100vw" }}
      transition={{ duration: 200, yoyo: Infinity }}
    >
      <Cloud color="#007CFF" />
    </motion.div>
  </Box>
)

const RedCloud = () => (
  <Box
    css={{ position: "absolute", zIndex: 10 }}
    sx={{ bottom: [-40, 100], right: 0 }}
  >
    <motion.div
      animate={{ x: "-100vw" }}
      transition={{ duration: 200, yoyo: Infinity }}
    >
      <Cloud color="#C03B3B" />
    </motion.div>
  </Box>
)

const Hero = () => (
  <Box
    py={[4, 5]}
    sx={{ borderColor: "text" }}
    css={{ borderBottom: "2px solid", position: "relative" }}
  >
    <BlueCloud />
    <RedCloud />
    <Flex
      alignItems="center"
      justifyContent="center"
      css={{ height: 200, textAlign: "center" }}
      mx="auto"
    >
      <Heading as="h1" variant="title">
        Uncanny <br />
        Valley
      </Heading>
    </Flex>
  </Box>
)

export default Hero
